module.exports = __webpack_public_path__ + "static/img/200182.521821dc.png";